import React from 'react';
export function AnnouncementBar() {
  return <div className="shimmer-animation text-center text-white text-xs font-medium tracking-widest uppercase py-2.5 px-5" style={{
    background: 'linear-gradient(90deg, var(--rose-deep), var(--lavender), var(--rose-deep))'
  }} data-id="element-15">
      ✦   Oferta especial por tiempo limitado   ✦     ✦   Kit completo 3×1   ·  
      73% de descuento   ✦
    </div>;
}